export function setupVoiceListener() {
  (window as any).onVoiceCommand = (command: string) => {
    console.log("Voice command received from iOS:", command);
    const event = new CustomEvent("voice-command", { detail: { command } });
    window.dispatchEvent(event);
  };
}

export function microphoneStatusListener() {
  (window as any).showMicrophoneStatus = (status: string) => {
    console.log("Microphone status received from iOS:", status);
    const event = new CustomEvent("microphone-status", { detail: { status } });
    window.dispatchEvent(event);
  };
}